import * as kissbotSocket from "./kissbot-socket-message-types";
export * from "./kissbot-socket-message-types";

export enum KissbotSocketType {
    CONVERSATION = 'conversation',
    ACTIVITY = 'activity',
    REMOVE_MEMBER = 'remove.member',
    ADD_MEMBER = 'add.member',
    WHATSAPP_WEB_QRCODE = 'whatsapp.web.qrcode',
    WHATSAPP_WEB_STATUS = 'whatsapp.web.status',
    CONVERSATION_UPDATED = 'conversation.updated',
    CONVERSATION_ASSUMED = 'conversation.assumed',
    CONVERSATION_TAGS_UPDATED = 'conversation.tags.updated',
    CONVERSATION_ATTRIBUTES_UPDATED = 'conversation.attributes.updated',
    CONVERSATION_MEMBERS_UPDATED = 'conversation.members.updated',
    CONVERSATION_MEMBER_UPDATED = 'conversation.member.updated',
    CONVERSATION_WHATSAPP_EXPIRATION_UPDATED = 'conversation.whatsapp_expiration.updated',
    WHATSWEB_CHECK_PHONE_NUMBER_RESPONSE = 'whatsweb.check_phone_number.response',
    ACTIVITY_ACK = 'activity.ack',
    UPDATE_ACTIVITY_ACK_AND_HASH = 'update.activity.ack_and_hash',
}

export type KissbotEventMessage =
    | kissbotSocket.IActivity
    | kissbotSocket.IConversation
    | kissbotSocket.IWhatswebQrCode
    | kissbotSocket.IWhatswebStatus
    | kissbotSocket.IConversationAttributes
    | kissbotSocket.IConversationTags
    | kissbotSocket.IConversationMembers 
    | kissbotSocket.IActivityAck
    | kissbotSocket.IConversationWhatsappExpirationUpdatedSocket

export interface KissbotSocket {
    message: KissbotEventMessage,
    type: KissbotSocketType;
    room?: string;
    timestamp?: number;
    id?: string;
}

export interface StreamUrlData {
    rooms?: string[];
    onConnect?: string;
    onMessageCallback?: string;
    channelId? : string;
    id?: string;
}